import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from './components/navbar/Navbar';
import { useState } from 'react';
import { UserProvider } from './components/userContext/UserContext';
import { MsalProvider } from '@azure/msal-react'; // MSAL integration
import { msalInstance } from './authConfig'; // MSAL instance configuration
import WelcomeUser from './components/welcome/WelcomeUser'; // Welcome message
import './App.css';

function App() {
  const location = useLocation();
  const hideNavbar = location.pathname === '/signin';
  const [mainMarginLeft, setMainMarginLeft] = useState('11rem');

  const handleNavbarToggle = (isOpen) => {
    setMainMarginLeft(isOpen ? '11rem' : '5rem');
  };

  return (
    <MsalProvider instance={msalInstance}>
      <UserProvider>
        {!hideNavbar && (
          <>
            <Navbar onToggle={handleNavbarToggle} />
            <WelcomeUser />
          </>
        )}
        <main style={hideNavbar ? {} : { marginLeft: mainMarginLeft }}>
          <Outlet />
        </main>
      </UserProvider>
    </MsalProvider>
  );
}

export default App;
